<!--
- 首页菜单待办按钮组件
-
- props:
- 1.examId
- 2.examName
- 3.subjectId
- 4.subjectName
-
- emit:
- 1.页面跳转
- menu-router-to()
-
- @author chenxb 2020-10-20 10:28:22
-->
<template>
<div class="menu-wrap">
  <el-popover
    placement="bottom-start"
    width="190"
    :visible-arrow = false
    trigger="click"
    popper-class='menu-list-popper'>
    <div class="menu-list">
      <div class="menu-item" v-for="(item, index) in currentmenuList" :key='index' @click="chooseMenu(item)">
        <div class="menu-item-wrap"  v-if="item.visible">
          <el-badge is-dot class="item" v-if="item.status == 'active'">
            {{item.label}}&nbsp;&nbsp;
          </el-badge>
          <span v-else-if="item.status == 'done'" class="menu-item-done">{{item.label}}</span>
          <span v-else>{{item.label}}</span>
          <i v-if="item.status == 'done'" class="el-icon-check"></i>
        </div>
      </div>
    </div>
    <el-badge slot="reference" :value="unDo" class="item" :hidden='unDo == 0'>
      <el-button class="pending-button" size="mini" plain>待处理</el-button>
    </el-badge>
  </el-popover>
  <!-- 使用is属性 用于避免各组件在未点击时 就已经开始加载 造成请求过多的问题 -->
  <component :is="currentView" :examId='examId' :subjectId='subjectId' :subjectName='subjectName' :examName='examName'
  :visible='dialogVisible' @dialog-close='dialogClose'></component>
</div>
</template>

<script>

import common from '@/util/common'
import CardCollection from '@/views/exam/task/card-collection/CardCollection'
import CardCollectionForSchool from '@/views/exam/task/card-collection/CardCollectionForSchool'
import OpenPreMark from '@/views/exam/open-pre-mark/OpenPreMark'
import OpenMark from '@/views/exam/open-mark/OpenMark'
import OpenMarkForSchool from '@/views/exam/open-mark/OpenMarkForSchool'
import GenerateSubjectScore from '@/views/exam/task/generate-subject-score/GenerateSubjectScore'

export default {
  props: {
    userId: {
      type: String,
      required: true
    },
    userRole: {
      type: String,
      required: true
    },
    examId: {
      type: String,
      required: true
    },
    subjectId: {
      type: String,
      required: true
    },
    examName: {
      type: String,
      required: true,
      default: ''
    },
    subjectName: {
      type: String,
      required: true,
      default: ''
    },
    examMonitorData: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      // 当前显示的组件名字
      currentView: '',
      dialogVisible: false,
      unDo: 0,
      // 待办事件菜单列表
      // role: 根据userInfo的role过滤显示
      // isDialog: 是以弹窗模式还是跳转
      menuListAll: [
        {
          label: '收集题卡信息',
          taskCode: 'COLLECT_CARD',
          status: 'pending',
          visible: false,
          role: ['2', '3'],
          isDialog: true,
          url: `/exam/card-collection/${this.examId}/${this.examName}/${this.subjectId}/${this.subjectName}`
        }, {
          label: '收集题卡信息',
          taskCode: 'COLLECT_CARD_SCHOOL',
          status: 'pending',
          visible: false,
          role: ['4'],
          isDialog: true,
          url: `/exam/card-collection-school/${this.examId}/${this.examName}/${this.subjectId}/${this.subjectName}`
        }, {
          label: '设置标答和分值',
          taskCode: 'SET_SUBJECTIVE_INFO',
          status: 'pending',
          visible: false,
          role: ['2', '3', '4', 'school'],
          isDialog: false,
          url: `/exam/omr-answer-score/${this.examId}/${this.examName}/${this.subjectId}/${this.subjectName}`
        }, {
          label: '设置主观题评卷参数',
          taskCode: 'SET_OBJECTIVE_INFO',
          status: 'pending',
          visible: false,
          role: ['2', '3', '4', 'school'],
          isDialog: false,
          url: `/exam/${this.examId}/${this.examName}/read-param/${this.subjectId}/${this.subjectName}`
        }, {
          label: '分配评卷任务',
          taskCode: 'ALLOT_TASK',
          status: 'pending',
          visible: false,
          role: ['2', '3'],
          isDialog: false,
          url: `/exam/task/${this.examId}/${this.subjectId}`
        }, {
          label: '分配评卷任务',
          taskCode: 'ALLOT_TASK',
          status: 'pending',
          visible: false,
          role: ['4', 'school'],
          isDialog: false,
          url: `/exam/task-school/${this.examId}/${this.subjectId}`
        }, {
          label: '开启试评',
          taskCode: 'SET_PJ_PARAM',
          status: 'hidden',
          visible: false,
          role: ['2', '3'],
          isDialog: true,
          url: 'exam/open-pre-mark'
        }, {
          label: '开启正评/重评',
          taskCode: 'PJ',
          status: 'hidden',
          visible: false,
          role: ['2', '3'],
          isDialog: true,
          url: 'exam/open-mark'
        }, {
          label: '开启正评/重评',
          taskCode: 'PJ_SCHOOL',
          status: 'hidden',
          visible: false,
          role: ['4', 'school'],
          isDialog: true,
          url: 'exam/open-mark-school'
        }, {
          label: '识别查看',
          taskCode: 'RECOGNITION_VIEW',
          status: 'hidden',
          visible: false,
          role: ['2', '3', '4', 'school'],
          isDialog: true,
          url: `/check-view-item/${this.userId}/${this.examId}/${this.examName}/${this.subjectId}/${this.subjectName}`
        }, {
          label: '出单科成绩',
          taskCode: 'END_PJ',
          status: 'pending',
          visible: false,
          role: ['2', '3', '4', 'school'],
          isDialog: true,
          url: `/exam/generate-subject-score/${this.examId}/${this.examName}/${this.subjectId}/${this.subjectName}`
        }
      ],
      currentmenuList: []
    }
  },
  created () {
  },
  mounted () {
    // this.getExamStatus()
    console.log(this.userId)
  },
  computed: {
    currentPosition () {
      return this.$store.getters.userSchoolPosition
    },
    positionRole () {
      let hasRole = false
      // 判断校内角色
      if (this.currentPosition) {
        if (['1', '2', '3'].includes(this.currentPosition.positionCode)) {
          hasRole = true
        }
      }
      return hasRole
    }
  },
  watch: {
    examMonitorData (data) {
      this.getExamStatus()
    }
  },
  methods: {
    getExamStatus () {
      // queryExamMonitor({
      //   examId: this.examId
      // }).then(res => {
      //   if (res.result === 'false') {
      //     // this.$message.error(res.errorMsg || '请检查是否开启试评')
      //     console.log(res.errorMsg)
      //   } else {
      //     let subjectMonitor = res.data.find(item => {
      //       return item.subjectId === this.subjectId
      //     })
      //     this.setExamStatus(subjectMonitor)
      //   }
      // })

      let subjectMonitor = this.examMonitorData.find(item => {
        return item.subjectId === this.subjectId
      })
      this.setExamStatus(subjectMonitor)
    },
    setExamStatus (data) {
      // 获取该权限下的待办菜单长度与已完成的待办事项总数
      let totalTodoNum = 0
      let hadDo = 0
      let tempUserRole = this.userRole
      let tempMenu = {}
      if (this.currentPosition && ['1', '2', '3'].includes(this.currentPosition.positionCode)) {
        tempUserRole = 'school'
      }
      console.log(tempUserRole)
      this.currentmenuList.splice(0, this.currentmenuList.length)
      this.menuListAll.map((menu, menuIndex) => {
        tempMenu = {...menu}
        data.monitorItems.map(item => {
          if (item.monitorName === menu.label && menu.role.includes(tempUserRole)) {
            tempMenu.visible = true
            // 过滤不同权限的待办菜单中的已完成项
            totalTodoNum++
            if (item.monitorProcess === '1') {
              tempMenu.status = 'done'
              hadDo++
            } else {
              tempMenu.status = 'pending'
            }
          }
        })
        // 增加手阅卡菜单
        if (data.subjectProType.toString() === '3') {
          if (tempMenu.taskCode === 'RECOGNITION_VIEW') {
            tempMenu.status = 'done'
          }
        }
        this.currentmenuList.push(tempMenu)
      })
      this.unDo = totalTodoNum - hadDo
      // 设置当前代办项
      let activeItem = this.currentmenuList.find((menu, menuIndex) => {
        return menu.status === 'pending'
      })
      if (activeItem) {
        activeItem.status = 'active'
      }
      console.log(this.currentmenuList)
    },
    // 点击选择待办项
    chooseMenu (item) {
      if (item.isDialog) {
        this.switchMenuOption(item)
      } else { // 不是弹窗的 直接跳转
        this.$emit('menu-router-to', item.url)
      }
    },
    // 切换组件显示
    switchMenuOption (menuItem) {
      switch (menuItem.taskCode) {
        case 'COLLECT_CARD':
          this.currentView = 'CardCollection'
          break
        case 'COLLECT_CARD_SCHOOL':
          this.currentView = 'CardCollectionForSchool'
          break
        case 'SET_PJ_PARAM':
          this.currentView = 'OpenPreMark'
          break
        case 'PJ':
          this.currentView = 'OpenMark'
          break
        case 'PJ_SCHOOL':
          this.currentView = 'OpenMarkForSchool'
          break
        case 'END_PJ':
          this.currentView = 'GenerateSubjectScore'
          break
        case 'RECOGNITION_VIEW':
          this.currentView = ''
          window.open(menuItem.url)
          break
        default:
          this.currentView = ''
          break
      }
      this.dialogVisible = true
    },
    dialogClose (payload) {
      this.dialogVisible = false
      this.$emit('dialog-close', payload)
    }
  },
  components: {
    CardCollection,
    CardCollectionForSchool,
    OpenPreMark,
    OpenMark,
    OpenMarkForSchool,
    GenerateSubjectScore
  }
}
</script>
<style lang="scss" >
  .el-popper.menu-list-popper{
    margin-top: 5px;
    .menu-list{
      padding: 10px 0;
      .menu-item{
        line-height: 2.2;
        padding: 0 12px;
        cursor: pointer;
        &:hover{
          color: #469046;
          font-weight: bold;
        }
        .menu-item-done{
          color: #c8c7bb;
        }
        .el-icon-check{
          color: #469046;
          font-weight: bold;
          margin-bottom: 8px;
          margin-left: 5px;
          font-size: 16px;
        }
        .menu-item-wrap{
          height: 38px;
          border-bottom: 1px dotted #f0f0fb;
          display: flex;
          align-items: flex-end;
        }
      }
    }
  }
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
  .menu-wrap{
    margin: 30px 0;
    .pending-button{
      &:hover, &:active, &:focus{
        color: #469046;
        border-color: transparent;
        background: #efefef
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/home/MenuList.vue